import { useTranslation } from 'react-i18next'
import { Card, IconButton, List, ListItem, ListItemText } from '@dhl-ui/components'
import { EditSolidIcon } from '@dhl-ui/icons'

type Props = {
  userBusinessUnits: string[]
  onEditClick: () => void
}

export const BusinessUnitsCard = ({ userBusinessUnits, onEditClick }: Props) => {
  const { t } = useTranslation()

  return (
    <Card>
      <Card.Header
        title={t('admin.adminUsersPage.businessUnitsPage.titleText')}
        endNode={
          <IconButton aria-label="edit admin business units" onClick={onEditClick}>
            <EditSolidIcon data-testid="edit-admin-business-units" />
          </IconButton>
        }
      />
      <Card.Content>
        <List>
          {userBusinessUnits.map((businessUnit) => (
            <ListItem key={`businessUnit-${businessUnit}`} hasDivider={false}>
              <ListItemText emphasis primary={t(`admin.adminUsersPage.businessUnitsPage.${businessUnit}`)} />
            </ListItem>
          ))}
        </List>
      </Card.Content>
    </Card>
  )
}
